import { render, staticRenderFns } from "./TreatmentImages.vue?vue&type=template&id=cf516df4&scoped=true"
import script from "./TreatmentImages.vue?vue&type=script&lang=js"
export * from "./TreatmentImages.vue?vue&type=script&lang=js"
import style0 from "./TreatmentImages.vue?vue&type=style&index=0&id=cf516df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf516df4",
  null
  
)

export default component.exports